import RiskName from "../riskName/riskName";
import { RisksId } from "../../../../helpers/risk";
import React from "react";
import { CalculateStore } from "../../../../stores/calculateStore";
import { inject, observer } from "mobx-react";
import InsuranceSum from "../insuranceSum/insuranceSum";
import { displayAdditionalRiskForm } from "../../../../helpers/risksNetwork";

interface OnlyInsuranceSumProps {
  calculateStore?: CalculateStore;
  riskId: RisksId;
  className?: string;
}

export function OnlyInsuranceSum(props: OnlyInsuranceSumProps) {
  const calculateStore = props.calculateStore!;

  if (!(props.riskId in calculateStore.additionalInsurances)) {
    return null;
  }

  // @ts-ignore
  const risk = calculateStore.additionalInsurances[props.riskId];
  const displayForm = displayAdditionalRiskForm(risk);

  return (
    <div className={`section only-insurance-sum ${props.className}`}>
      <RiskName
        checkboxOnChange={(event) => {
          calculateStore.setAdditionalInsuranceFieldChecked(props.riskId, event.target.checked);
        }}
        riskId={props.riskId}
        displayIcon={true}
      />

      {displayForm && (
        <InsuranceSum riskId={props.riskId} />
      )}
    </div>
  );
}

export default inject("calculateStore")(observer(OnlyInsuranceSum));
